import useDefinedContext from "hooks/useDefinedContext";
import MultiSelectContext from "../SetMultiSelectContext";

function useSetMultiSelect() {
  return useDefinedContext(MultiSelectContext);
}

export default useSetMultiSelect;
